/* eslint-disable hubspot-dev/no-private-classes */
/**
 * These labels are static labels used for navigation that do not need to be translated.
 */
export const staticLabels = {
  '/reference/cms/modules/export-to-template-context': 'export_to_template_context',
  '/reference/cms/react': 'CMS React',
  '/reference/ui-components/crm-action-components/crm-action-button': 'CrmActionButton',
  '/reference/ui-components/crm-action-components/crm-action-link': 'CrmActionLink',
  '/reference/ui-components/crm-action-components/crm-card-actions': 'CrmCardActions',
  '/reference/ui-components/crm-data-components/crm-association-pivot': 'CrmAssociationPivot',
  '/reference/ui-components/crm-data-components/crm-association-property-list': 'CrmAssociationPropertyList',
  '/reference/ui-components/crm-data-components/crm-association-stage-tracker': 'CrmAssociationStageTracker',
  '/reference/ui-components/crm-data-components/crm-association-table': 'CrmAssociationTable',
  '/reference/ui-components/crm-data-components/crm-data-highlight': 'CrmDataHighlight',
  '/reference/ui-components/crm-data-components/crm-property-list': 'CrmPropertyList',
  '/reference/ui-components/crm-data-components/crm-report': 'CrmReport',
  '/reference/ui-components/crm-data-components/crm-stage-tracker': 'CrmStageTracker',
  '/reference/ui-components/crm-data-components/crm-statistics': 'CrmStatistics',
  '/reference/ui-components/standard-components/accordion': 'Accordion',
  '/reference/ui-components/standard-components/alert': 'Alert',
  '/reference/ui-components/standard-components/box': 'Box',
  '/reference/ui-components/standard-components/button-row': 'ButtonRow',
  '/reference/ui-components/standard-components/button': 'Button',
  '/reference/ui-components/standard-components/charts/bar-chart': 'BarChart',
  '/reference/ui-components/standard-components/charts/line-chart': 'LineChart',
  '/reference/ui-components/standard-components/checkbox': 'Checkbox',
  '/reference/ui-components/standard-components/date-input': 'DateInput',
  '/reference/ui-components/standard-components/description-list': 'DescriptionList',
  '/reference/ui-components/standard-components/divider': 'Divider',
  '/reference/ui-components/standard-components/dropdown': 'Dropdown',
  '/reference/ui-components/standard-components/empty-state': 'EmptyState',
  '/reference/ui-components/standard-components/error-state': 'ErrorState',
  '/reference/ui-components/standard-components/flex': 'Flex',
  '/reference/ui-components/standard-components/form': 'Form',
  '/reference/ui-components/standard-components/heading': 'Heading',
  '/reference/ui-components/standard-components/icon': 'Icon',
  '/reference/ui-components/standard-components/illustration': 'Illustration',
  '/reference/ui-components/standard-components/image': 'Image',
  '/reference/ui-components/standard-components/input': 'Input',
  '/reference/ui-components/standard-components/link': 'Link',
  '/reference/ui-components/standard-components/list': 'List',
  '/reference/ui-components/standard-components/loading-button': 'LoadingButton',
  '/reference/ui-components/standard-components/loading-spinner': 'LoadingSpinner',
  '/reference/ui-components/standard-components/modal': 'Modal',
  '/reference/ui-components/standard-components/multi-select': 'MultiSelect',
  '/reference/ui-components/standard-components/number-input': 'NumberInput',
  '/reference/ui-components/standard-components/panel': 'Panel',
  '/reference/ui-components/standard-components/progress-bar': 'ProgressBar',
  '/reference/ui-components/standard-components/radio-button': 'RadioButton',
  '/reference/ui-components/standard-components/select': 'Select',
  '/reference/ui-components/standard-components/statistics': 'Statistics',
  '/reference/ui-components/standard-components/status-tag': 'StatusTag',
  '/reference/ui-components/standard-components/step-indicator': 'StepIndicator',
  '/reference/ui-components/standard-components/stepper-input': 'StepperInput',
  '/reference/ui-components/standard-components/table': 'Table',
  '/reference/ui-components/standard-components/tabs': 'Tabs',
  '/reference/ui-components/standard-components/tag': 'Tag',
  '/reference/ui-components/standard-components/text-area': 'TextArea',
  '/reference/ui-components/standard-components/text': 'Text',
  '/reference/ui-components/standard-components/tile': 'Tile',
  '/reference/ui-components/standard-components/toggle-group': 'ToggleGroup',
  '/reference/ui-components/standard-components/toggle': 'Toggle',
  '/guides/api/cms/hubdb': 'HubDB',
  '/guides/cms/content/data-driven-content/dynamic-pages/hubdb': 'HubDB',
  '/guides/cms/quickstart': 'Quickstart',
  '/guides/cms/react': 'CMS React'
};